
import avatar from '@/assets/images/public/user-circle.png';
import AppLink from '@/components/common/link';
import router from '@/core/router';
import appConfig from '@/config/app';

const page = {
    data() {
        return {
            appHost:'/',
            avatar: avatar
        }
    },
    props: {
    },
    components: { AppLink },
    computed: {},
    methods: {
        async logout() {
            const href = appConfig.domain.app;
            await this.$store.dispatch("user/logout").then(() => {
                document.location.href = href;
            }); 
        },
        linkAccount() {
            this.$router.push({ path: '/account/index' });
        }
    },
	created: function () {
        this.appHost = appConfig.domain.app; 
	}
}
export default page


// WEBPACK FOOTER //
// ./src/layout/master/components/navbar/index.js